/**
 * Returns the base URL for shareable links.
 * Uses VITE_APP_URL in production/mobile builds (where window.location.origin
 * would be capacitor://localhost), falling back to window.location.origin for web dev.
 */
export function getShareBaseUrl(): string {
  const configured = import.meta.env.VITE_APP_URL;
  return configured || window.location.origin;
}
